import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import AutomationScheduleListBody from "components/AutomationComponents/AutomationScheduleListBody/AutomationScheduleListBody";

const AutomationScheduleList = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Automation Schedule List";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="automation" />

      <AutomationScheduleListBody />
    </main>
  );
};

export default AutomationScheduleList;
